<template>
  <section ref="sectionRef">
    <header class="mb-24 md:mb-32 md:text-center">
      <h3 class="heading-3 mb-12">{{ i18n(translations.productFeature) }}</h3>
      <h4 class="punchline-sans">
        {{ i18n(translations.thoroughQualityCheck) }}
      </h4>
    </header>

    <p class="body-1 mb-24 md:mb-32 md:text-center">
      {{ i18n(translations.introDescription) }}
    </p>

    <div class="flex flex-col gap-32">
      <HygieneStep
        :content="i18n(translations.step01Content)"
        :heading="i18n(translations.step01Heading)"
        image-src="/img/product/jp/step-hygiene-01.png"
        :step-label="i18n(translations.step01Label)"
      />

      <HygieneStep
        :content="i18n(translations.step02Content)"
        :heading="i18n(translations.step02Heading)"
        image-src="/img/product/jp/step-hygiene-02.png"
        :step-label="i18n(translations.step02Label)"
      />

      <HygieneStep
        :content="i18n(translations.step03Content)"
        :heading="i18n(translations.step03Heading)"
        image-src="/img/product/jp/step-hygiene-03.png"
        :step-label="i18n(translations.step03Label)"
      />

      <HygieneStep
        :content="i18n(translations.step04Content)"
        :heading="i18n(translations.step04Heading)"
        image-src="/img/product/jp/step-hygiene-04.png"
        :step-label="i18n(translations.step04Label)"
      />
    </div>
  </section>
</template>

<script lang="ts" setup>
import { onUnmounted, ref } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { useIntersectionObserver } from '@vueuse/core'

import translations from './AboutHygieneBlock.translations'
import HygieneStep from './components/HygieneStep.vue'

const i18n = useI18n()

const { trackProductBlockImpression } = useTracking()

const sectionRef = ref<HTMLElement | null>()

const { stop } = useIntersectionObserver(sectionRef, ([{ isIntersecting }]) => {
  if (isIntersecting) {
    trackProductBlockImpression({
      block_name: 'hygiene_block',
    })
  }
})

onUnmounted(() => {
  stop()
})
</script>
